import { FormData } from "@myloc/myg-forms";
import {
  FormData as FormDataType,
  FormDefinition,
  FormSequence,
  ProcessedFormSequence,
} from "../../../../../../services/registerAction/types";
import styles from "./ActionFormStep.module.scss";

interface ActionFormStepProps {
  formDefinition: FormDefinition;
  onNext: (data: FormDataType) => void;
}

const getUpdateFormSequenceRequest = (sequences: FormSequence[]): ProcessedFormSequence[] => {
  const data: ProcessedFormSequence[] = [];

  for (const sequence of sequences) {
    if ("type" in sequence) {
      data.push({
        id: sequence.id,
        value: sequence.value !== "" ? sequence.value : null,
      });
    } else if (sequence.sequences) {
      data.push({
        id: sequence.id,
        sequences: getUpdateFormSequenceRequest(sequence.sequences),
      });
    }
  }

  return data;
};

const ActionFormStep = ({ formDefinition, onNext }: ActionFormStepProps) => {
  const handleSubmit = (form: { id: string; sequences: FormSequence[] }) => {
    const processedData = getUpdateFormSequenceRequest(form.sequences);

    onNext({ sequences: processedData, id: form.id });
  };

  return (
    <div className={styles.container}>
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      <FormData form={formDefinition as any} onSubmit={handleSubmit as any} inputMode showNextButton />
    </div>
  );
};

export default ActionFormStep;
